export const EVENT_NOTES = 'Notes'
